import { Row, Col, Button, Card, Form } from 'react-bootstrap';
import Footer from "../component/Footer";
import Header from "../component/Header";
import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Toast from 'react-bootstrap/Toast';

import secureLocalStorage from 'react-secure-storage';
import setting from '../setting.json';
import Image from 'react-bootstrap/Image';
import { useNavigate, useLocation } from 'react-router-dom';

const schema = yup.object().shape({
});

const Payment = () => {
    const navigate = useNavigate()
    const [add, setAdd] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [coursecList, setCoursecList] = useState([]);
    const [majorList, setMajorList] = useState([]);
    const [minorList, setMinorList] = useState([]);
    const [vo_courseList, setVo_courseList] = useState([]);
    const [curricularSubject, setCoCurricularSubject] = useState([]);


    const location = useLocation();
    const { id, name, application, father } = location.state || {};

    const {
        register,
        handleSubmit,
        reset,
        setError,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),

    })


    const [paymentMode, setPaymentMode] = useState('')
    const [amount, setAmount] = useState('')
    const [transactionNumber, setTransactionNumber] = useState('')
    const [screenshot, setScreenshot] = useState(null)

    const [toast, setToast] = useState()
    const toaster = useRef(null)

    const getToast = (message, type = 'success') => (
        <Toast autohide={true} visible={true} delay={3000}>
            <Toast.Header closeButton>
                <svg className="rounded me-2" width="20" height="20">
                    <rect width="100%" height="100%" fill={type === 'success' ? '#28a745' : '#dc3545'}></rect>
                </svg>
                <strong className="me-auto">{type === 'success' ? 'Success' : 'Error'}</strong>
                <small>Now</small>
            </Toast.Header>
            <Toast.Body>{message}</Toast.Body>
        </Toast>
    );






    const savePayment = async (data) => {
        // console.log(name);

        let db = new FormData();
        console.log(paymentMode);
        db.append('id', id)
        db.append('mode', paymentMode)
        db.append('amount', amount)
        if (paymentMode == 'cash') {
            db.append('trans_no', 0);
        }


        if (paymentMode == 'online') {
            db.append('trans_no', transactionNumber)
            if (screenshot) {
                db.append('screenshot', screenshot)
            }
        }
        console.log(db);

        await fetch(setting.api + 'student/savePayment', {
            body: db,
            method: "post",
            mode: "cors",
            headers: {
                // "Authorization": 'Bearer ' + JSON.parse(secureLocalStorage.getItem("logininfo")).token,
            },

        })

            .then(response => response.json())
            .then(u => {

                if (u.result === "success") {
                    setToast(getToast('Payment Successfully'));


                    navigate('/success', {
                        state: {
                            // name,
                            transactionNumber: data.transactionNumber,
                            amount
                        }
                    })
                }
                else {

                    setToast(getToast(u.message || 'Payment failed.', 'error'));
                }


            });

    }






    return (

        <>
            <Header />

            <section className="page-header bg_img"
                style={{
                    backgroundImage: "URL(./images/banner2.jpg)",
                    height: "30lvh",
                }}
            >
                <div className="container">
                    <div className="page-header-content">
                        <h1 className="title">Payment Form</h1>
                        <ul className="breadcrumb">
                            <li>
                                <a href="/">Home</a>
                            </li>

                            <li> Payment Form </li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* <div className="student-page">
                <section className="teacher-section py-3 bg_img "> */}
            <div className="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="section-header">

                            <Card style={{ maxWidth: '500px' }}>

                                <Card.Body>

                                    {/* <div >
                        <div className="d-flex mb-2">
                            <div style={{ width: '150px', fontWeight: 'bold' }}>Name:</div>
                            <div>{name || '-'}</div>
                        </div>
                        <div className="d-flex mb-2">
                            <div style={{ width: '150px', fontWeight: 'bold' }}>Application No:</div>
                            <div>{application || '-'}</div>
                        </div>
                        <div className="d-flex">
                            <div style={{ width: '150px', fontWeight: 'bold' }}>Father's Name:</div>
                            <div>{father || '-'}</div>
                        </div>
                    </div>
                    <br /> */}

                                    <Form onSubmit={handleSubmit(savePayment)}>
                                        <div className="mb-3">

                                            <Form.Label><b>Select Payment Mode</b></Form.Label>
                                            <Form.Select
                                                value={paymentMode}
                                                onChange={(e) => {
                                                    setPaymentMode(e.target.value)
                                                    setAmount('')
                                                    setTransactionNumber('')
                                                    setScreenshot(null)
                                                }}
                                                required
                                            >
                                                <option value="">-- Select --</option>
                                                <option value="cash">Cash</option>
                                                <option value="online">Online</option>


                                            </Form.Select>
                                        </div>

                                        {paymentMode && (
                                            <div className="mb-3">
                                                <Form.Label>Transaction Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder='Enter Transaction Amount'
                                                    value={amount}
                                                    onChange={(e) => setAmount(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        )}

                                        {paymentMode === 'online' && (
                                            <>


                                                <div className="mb-3 text-center">
                                                    <div>
                                                        <Image
                                                            src={process.env.BASEURL + '/uploads/qr.jpg'}
                                                            alt="QR Code"
                                                            width={170}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mb-3">
                                                    <Form.Label>Transaction Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={transactionNumber}
                                                        {...register("transactionNumber")}
                                                        placeholder='Enter Transaction Number'
                                                        onChange={(e) => setTransactionNumber(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Form.Label>Upload Transaction Screenshot</Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        accept="image/*"

                                                        onChange={(e) => setScreenshot(e.target.files[0])}

                                                    />
                                                </div>
                                            </>
                                        )}

                                        <Row className="mt-3">
                                            <Col xs={9}>
                                                <Button type="submit" color="primary" className="w-100">
                                                    Submit
                                                </Button>
                                            </Col>
                                            <Col xs={3}>
                                                <Button
                                                    type="button"
                                                    color="secondary"
                                                    className="w-100"
                                                    onClick={() => navigate('/dashboard')}
                                                >
                                                    Pay later
                                                </Button>
                                            </Col>
                                        </Row>


                                    </Form>
                                </Card.Body>
                            </Card >
                        </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
}
export default Payment;